import * as React from "react";
import {
    Typography,
    Box,
    Card,
    CardContent,
    Tabs,
    Tab,
    CircularProgress,
    TextField,
    Modal,
    Tooltip,
    Paper,
} from "@mui/material";
import { connect } from "react-redux";
import { useNavigate, useSearchParams } from "react-router-dom";
import { Button, notification, Space, Table, Tag } from "antd";
import { isMobile } from "react-device-detect";
import {
  antTableWrapperSx,
  defaultPaginatedTableProps,
  idTableColumn,
} from "../../app/components/AntTableStyles";
import {
    getNoShippingOrders,
    getLateFulfillmentOrders,
    getLateDeliveryOrders,
    getLateReturnsOrders,
    getLatePickupOrders,
    setOrderReturnedToChainz,
    getVendors,
    recreateOrder,
    resetOrder,
    silentCancelOrder
} from "../../app/store/actions/imsAdminActions";
import moment from "moment";
import download from "downloadjs";
import { centered_flex_box, MainInput, left_flex_box } from "../../app/components/Styles";
import { BrandSelect } from "../../app/components/BrandSelect";
import { downloadShippingAwbs, getOrderAwbService, isFincartAwbEligible, parseAwbError } from "../../app/utils/shippingAwb";
import { getOrderCourierLabel, getOrderTrackingId } from "../../app/utils/shippingDisplay";
import { CancelOrderModal } from "../shared/CancelOrderModal";

export const ActionCenter = ({
    getNoShippingOrders,
    getLateFulfillmentOrders,
    getLateDeliveryOrders,
    getLateReturnsOrders,
    getLatePickupOrders,
    getVendors,
    noShippingOrders,
    lateFulfillmentOrders,
    lateDeliveryOrders,
    lateReturnsOrders,
    latePickupOrders,
    silentCancelOrder,
    vendors,
    isLoading,
    setOrderReturnedToChainz,
    recreateOrder,
    resetOrder,
    token
}) => {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const ACTION_CENTER_TABS = ["noShipping", "lateFulfillment", "lateDelivery", "lateReturns", "latePickup"];
    const tabFromUrl = searchParams.get("tab");
    const [activeTab, setActiveTab] = React.useState(() => {
        if (tabFromUrl && ACTION_CENTER_TABS.includes(tabFromUrl)) {
            return ACTION_CENTER_TABS.indexOf(tabFromUrl);
        }
        const saved = sessionStorage.getItem('actionCenter_tab');
        return saved ? JSON.parse(saved) : 0;
    });
    const [page, setPage] = React.useState(() => {
        if (tabFromUrl && ACTION_CENTER_TABS.includes(tabFromUrl)) return 1;
        const saved = sessionStorage.getItem('actionCenter_page');
        return saved ? JSON.parse(saved) : 1;
    });
    const [vendorId, setVendorId] = React.useState(() => {
        if (tabFromUrl && ACTION_CENTER_TABS.includes(tabFromUrl)) return null;
        const saved = sessionStorage.getItem('actionCenter_vendorId');
        return saved ? JSON.parse(saved) : null;
    });
    const [search, setSearch] = React.useState(() => {
        const saved = sessionStorage.getItem('actionCenter_search');
        return saved ? JSON.parse(saved) : '';
    });
    const [isNavigatingBack, setIsNavigatingBack] = React.useState(false);
    const [isInitialLoad, setIsInitialLoad] = React.useState(true);
    const [gettingAWB, setGettingAWB] = React.useState(false);
    const searchTimeoutRef = React.useRef(null);
    const [selectedExceptions, setSelectedExceptions] = React.useState(null);
    const [cancelModalOpen, setCancelModalOpen] = React.useState(false);
    const [orderToCancel, setOrderToCancel] = React.useState(null);
    const [isCancelling, setIsCancelling] = React.useState(false);

    // Handle browser back/forward navigation
    React.useEffect(() => {
        const handlePopState = () => {
            setIsNavigatingBack(true);
            const savedPage = sessionStorage.getItem('actionCenter_page');
            if (savedPage) {
                setPage(JSON.parse(savedPage));
            }
        };

        window.addEventListener('popstate', handlePopState);
        return () => window.removeEventListener('popstate', handlePopState);
    }, []);

    // Save state to sessionStorage whenever it changes
    React.useEffect(() => {
        sessionStorage.setItem('actionCenter_tab', JSON.stringify(activeTab));
    }, [activeTab]);

    React.useEffect(() => {
        sessionStorage.setItem('actionCenter_page', JSON.stringify(page));
    }, [page]);

    React.useEffect(() => {
        sessionStorage.setItem('actionCenter_vendorId', JSON.stringify(vendorId));
    }, [vendorId]);

    React.useEffect(() => {
        sessionStorage.setItem('actionCenter_search', JSON.stringify(search));
    }, [search]);

    const fetchTab = (tab, params) => {
        switch (tab) {
            case 0:
                getNoShippingOrders(params);
                break;
            case 1:
                getLateFulfillmentOrders(params);
                break;
            case 2:
                getLateDeliveryOrders(params);
                break;
            case 3:
                getLateReturnsOrders(params);
                break;
            case 4:
                getLatePickupOrders(params);
                break;
            default:
                break;
        }
    };

    // Initial data load
    React.useEffect(() => {
        if (isInitialLoad) {
            getVendors({ page: 1, limit: 100 });
            const params = { page: 1, limit: 50, vendorId, search };
            fetchTab(activeTab, params);
            setIsInitialLoad(false);
        }
    }, [isInitialLoad]);

    const handleSearchChange = (event) => {
        const value = event.target.value;
        setSearch(value);

        // Clear any existing timeout
        if (searchTimeoutRef.current) {
            clearTimeout(searchTimeoutRef.current);
        }

        // Set a new timeout
        searchTimeoutRef.current = setTimeout(() => {
            setPage(1);
            const params = { page: 1, limit: 50, vendorId, search: value };
            switch (activeTab) {
                case 0:
                    getNoShippingOrders(params);
                    break;
                case 1:
                    getLateFulfillmentOrders(params);
                    break;
                case 2:
                    getLateDeliveryOrders(params);
                    break;
                case 3:
                    getLateReturnsOrders(params);
                    break;
                case 4:
                    getLatePickupOrders(params);
                    break;
                default:
                    break;
            }
        }, 500); // 500ms delay
    };

    const getCurrentOrders = () => {
        switch (activeTab) {
            case 0:
                return noShippingOrders;
            case 1:
                return lateFulfillmentOrders;
            case 2:
                return lateDeliveryOrders;
            case 3:
                return lateReturnsOrders;
            case 4:
                return latePickupOrders;
            default:
                return null;
        }
    };

    const handleViewExceptions = (exceptions) => {
        setSelectedExceptions(exceptions);
    };

    const handleCloseExceptions = () => {
        setSelectedExceptions(null);
    };

    const handleOpenCancelModal = (orderId) => {
        setOrderToCancel(orderId);
        setCancelModalOpen(true);
    };

    const handleConfirmCancel = (cancellationReason) => {
        if (!orderToCancel) return;
        setIsCancelling(true);
        silentCancelOrder({ orderId: orderToCancel, cancellationReason }, (success) => {
            setIsCancelling(false);
            if (success) {
                setCancelModalOpen(false);
                setOrderToCancel(null);
                getLateFulfillmentOrders({ page, limit: 50, vendorId, search });
            }
        });
    };

    const columns = [
        idTableColumn(),
        {
            title: 'Shopify Number',
            dataIndex: 'shopifyOrderNumber',
        },
        {
            title: 'Tracking ID',
            dataIndex: 'trackingId',
        },
        {
            title: 'Courier',
            dataIndex: 'courier',
        },
        {
            title: 'Date Ordered',
            dataIndex: 'date',
        },
        {
            title: 'Date Fulfilled',
            dataIndex: 'dateFulfilled',
        },
        {
            title: 'Date Delivered',
            dataIndex: 'dateDelivered',
        },
        {
            title: 'Customer Name',
            dataIndex: 'customer',
        },
        {
            title: 'Customer Phone',
            dataIndex: 'phone',
        },
        {
            title: 'Status',
            dataIndex: 'status',
            render: (_, { status }) => <Tag color={status === "Delivered" ? "green" : status === "Cancelled" ? "red" : status === "Prepared" ? "blue" : "yellow"}>{(status || "Unknown").toUpperCase()}</Tag>
        },
        {
            title: 'Vendor',
            dataIndex: 'vendor',
        },
        {
            title: 'Actions',
            render: (_, record) => <Space>
                <Button onClick={() => navigate(`/ims/admin/order/${record._id}`)}>View Order</Button>
                {activeTab === 1 && getOrderAwbService(record) !== "Fincart" && <Button onClick={() => handlePrintAWB(record)}>Print AWB</Button>}
                {activeTab === 1 && getOrderAwbService(record) === "Fincart" && isFincartAwbEligible(record) && <Button onClick={() => handlePrintAWB(record)}>Print AWB</Button>}
                {activeTab === 1 && <Button onClick={() => handleOpenCancelModal(record._id)}>Cancel Order</Button>}
                {activeTab === 1 && moment().diff(moment(record.createdAt), "days") >= 10 && (
                    <Button onClick={() => recreateOrder({orderId: record._id})}>Recreate Order</Button>
                )}

                {activeTab === 1 && record.status === "Preparing" && (
                    <Button onClick={() => resetOrder({orderId: record._id})}>Reset Order Packing</Button>
                )}
                {activeTab === 2 && (record.bostaExceptions?.length > 0 || record.fincartExceptions?.length > 0) && (
                    <Button onClick={() => handleViewExceptions(record.bostaExceptions || record.fincartExceptions)}>View Exceptions</Button>
                )}
                {activeTab === 3 && <Button onClick={() => setOrderReturnedToChainz({ orderId: record._id })}>Set as Returned to Chainz</Button>}
            </Space>
        },
    ];

    const data = getCurrentOrders()?.docs?.map((row) => {
        return {
            _id: row._id,
            trackingId: getOrderTrackingId(row),
            courier: getOrderCourierLabel(row, row.vendor),
            shopifyOrderNumber: row.shopifyOrderNumber,
            date: moment(row.createdAt).format("lll"),
            createdAt: row.createdAt,
            dateFulfilled: row.preparedAt ? moment(row.preparedAt).format("lll") : null,
            dateDelivered: row.deliveredAt ? moment(row.deliveredAt).format("lll") : null,
            status: row.status,
            customer: row.fulfillment?.customer,
            phone: row.fulfillment?.phone,
            vendor: row.vendor?.brandName || row.vendor?.name || "N/A",
            bostaExceptions: row.bostaExceptions,
            fincartExceptions: row.fincartExceptions,
            fincartId: row.fincartId,
            courierTrackingId: row.courierTrackingId,
            fincartCourier: row.fincartCourier,
            shipbluTrackingId: row.shipbluTrackingId,
            bostaTrackingId: row.bostaTrackingId,
        }
    });

    // Handle page changes
    React.useEffect(() => {
        if (!isNavigatingBack && !isInitialLoad) {
            const params = { page, limit: 50, vendorId, search };
            switch (activeTab) {
                case 0:
                    getNoShippingOrders(params);
                    break;
                case 1:
                    getLateFulfillmentOrders(params);
                    break;
                case 2:
                    getLateDeliveryOrders(params);
                    break;
                case 3:
                    getLateReturnsOrders(params);
                    break;
                case 4:
                    getLatePickupOrders(params);
                    break;
                default:
                    break;
            }
        }
        setIsNavigatingBack(false);
    }, [page]);

    // Handle filter changes
    React.useEffect(() => {
        if (!isNavigatingBack && !isInitialLoad) {
            setPage(1);
            const params = { page: 1, limit: 50, vendorId, search };
            switch (activeTab) {
                case 0:
                    getNoShippingOrders(params);
                    break;
                case 1:
                    getLateFulfillmentOrders(params);
                    break;
                case 2:
                    getLateDeliveryOrders(params);
                    break;
                case 3:
                    getLateReturnsOrders(params);
                    break;
                case 4:
                    getLatePickupOrders(params);
                    break;
                default:
                    break;
            }
        }
    }, [vendorId, activeTab]);

    const handlePrintAWB = async (order) => {
        const service = getOrderAwbService(order);
        if (!service) {
            return;
        }
        if (service === "Fincart" && !isFincartAwbEligible(order)) {
            notification.error({
                message: "Fincart AWB not available",
                description: "Fincart labels can only be printed for New or Pending Confirmation orders.",
                style: { marginTop: "10vh" }
            });
            return;
        }

        setGettingAWB(true);
        try {
            const data = await downloadShippingAwbs({
                token,
                apiBasePath: "IMAdmin",
                service,
                trackingNumbers: service === "Fincart"
                    ? []
                    : [order?.shipbluTrackingId || order?.bostaTrackingId].filter(Boolean),
                fincartOrderIds: service === "Fincart" ? [order.fincartId] : [],
            });

            const fileName = service === "ShipBlu"
                ? `Order ${order?.shipbluTrackingId} AWBs.pdf`
                : service === "Fincart"
                    ? `Order ${order?.courierTrackingId || order?.fincartCode} AWBs.pdf`
                    : `Order ${order?.bostaTrackingId} AWBs.pdf`;

            download(data, fileName, "application/pdf");
        } catch (error) {
            notification.error({
                message: "Error",
                description: parseAwbError(error, service),
                style: { marginTop: "10vh" }
            });
        } finally {
            setGettingAWB(false);
        }
    };

    return (
        <div>
            <Box sx={{ width: "100%", padding: 5 }}>
                <Box sx={{ ...centered_flex_box, mb: 1 }}>
                    <Typography variant='h4' sx={{ color: "var(--secColor)" }}>Action Center</Typography>
                </Box>
                <Card sx={{ mb: 3 }}>
                    <CardContent>
                        <Tabs value={activeTab} onChange={(e, newValue) => setActiveTab(newValue)}>
                            <Tab label="No Shipping Orders" />
                            <Tab label="Late Fulfillment" />
                            <Tab label="Late Delivery" />
                            <Tab label="Late Returns" />
                            <Tab label="Late Pickup" />
                        </Tabs>
                    </CardContent>
                </Card>
                <Box sx={{ ...centered_flex_box, mb: 2 }}>
                    <Card sx={{ width: "100%" }}>
                        <CardContent>
                            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
                                <Box sx={{ display: 'flex', gap: 2 }}>
                                    <BrandSelect
                                        vendors={vendors}
                                        value={vendorId}
                                        label="Filter by Vendor"
                                        emptyLabel="All vendors"
                                        sx={{ flex: 1 }}
                                        onChange={(id) => setVendorId(id)}
                                    />
                                    <TextField
                                        sx={{ flex: 1 }}
                                        margin="normal"
                                        label="Search by Name, Phone, Order Number or Tracking ID"
                                        value={search}
                                        onChange={handleSearchChange}
                                        fullWidth
                                    />
                                </Box>
                            </Box>
                        </CardContent>
                    </Card>
                </Box>
                <Box sx={antTableWrapperSx(isMobile)}>
                  <Table
                    columns={columns}
                    dataSource={data}
                    loading={isLoading || gettingAWB}
                    showSorterTooltip={{
                      target: 'sorter-icon',
                    }}
                    pagination={defaultPaginatedTableProps({
                      current: page,
                      pageSize: parseInt(getCurrentOrders()?.limit || 50),
                      total: getCurrentOrders()?.totalDocs,
                      onChange: (nextPage) => setPage(nextPage),
                    })}
                    scroll={{ x: isMobile ? 300 : 1200 }}
                  />
                </Box>
            </Box>

            <Modal
                open={selectedExceptions !== null}
                onClose={handleCloseExceptions}
                aria-labelledby="exceptions-modal-title"
            >
                <Box sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: 400,
                    bgcolor: 'background.paper',
                    boxShadow: 24,
                    p: 4,
                    borderRadius: 2,
                    maxHeight: '80vh',
                    overflow: 'auto'
                }}>
                    <Typography id="exceptions-modal-title" variant="h6" component="h2" sx={{ mb: 2 }}>
                        Bosta / Fincart Exceptions
                    </Typography>
                    {selectedExceptions?.map((exception, index) => (
                        <Box key={index} sx={{ mb: 2, p: 2, bgcolor: 'grey.100', borderRadius: 1 }}>
                            <Typography variant="body1" sx={{ fontWeight: 'bold', mb: 1 }}>
                                {exception.exception}
                            </Typography>
                            {exception.reason && (
                                <Typography variant="body2" sx={{ mb: 1 }}>
                                    Reason: {exception.reason}
                                </Typography>
                            )}
                            {exception.date && (
                                <Typography variant="body2" color="text.secondary">
                                    Date: {moment(exception.date).format('lll')}
                                </Typography>
                            )}
                        </Box>
                    ))}
                    <Box sx={{ mt: 2, display: 'flex', justifyContent: 'flex-end' }}>
                        <Button onClick={handleCloseExceptions}>Close</Button>
                    </Box>
                </Box>
            </Modal>
            <CancelOrderModal
                open={cancelModalOpen}
                onClose={() => {
                    if (!isCancelling) {
                        setCancelModalOpen(false);
                        setOrderToCancel(null);
                    }
                }}
                onConfirm={handleConfirmCancel}
                isLoading={isCancelling}
            />
        </div>
    );
};

const mapStateToProps = (state) => ({
    isLoading: state?.records?.isLoading,
    token: state?.auth?.token,
    noShippingOrders: state?.records?.ordersWithoutShipping,
    lateFulfillmentOrders: state?.records?.lateOrders,
    lateDeliveryOrders: state?.records?.lateDeliveryOrders,
    lateReturnsOrders: state?.records?.lateReturnOrders,
    latePickupOrders: state?.records?.latePickupOrders,
    vendors: state?.records?.vendors
});

const mapDispatchToProps = {
    getNoShippingOrders,
    getLateFulfillmentOrders,
    getLateDeliveryOrders,
    getLateReturnsOrders,
    getLatePickupOrders,
    getVendors,
    setOrderReturnedToChainz,
    recreateOrder,
    resetOrder,
    silentCancelOrder
};

export default connect(mapStateToProps, mapDispatchToProps)(ActionCenter);
